import { StyleSheet, Platform } from "react-native";

export default StyleSheet.create({
  root: {
    flexGrow: 1,
    backgroundColor: "#f8fbff",
    paddingTop: 24,
    paddingBottom: 48,
    paddingHorizontal: 16,
    alignItems: "center",
  },
  pageHeader: {
    width: "100%",
    maxWidth: 760,
    marginBottom: 18,
  },
  pageTitle: {
    fontSize: 30,
    fontWeight: "800",
    color: "#111827",
    marginBottom: 8,
  },
  pageSubtitle: {
    fontSize: 15,
    color: "#4b5563",
    lineHeight: 22,
  },
  infoRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
    justifyContent: "space-between",
  },
  infoBlock: {
    flex: 1,
    minWidth: Platform.OS === "web" ? 180 : 140,
    backgroundColor: "#f8fafc",
    borderRadius: 16,
    padding: 14,
  },
  infoLabel: {
    fontSize: 12,
    color: "#6b7280",
    marginBottom: 6,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  infoValue: {
    fontSize: 16,
    fontWeight: "700",
    color: "#111827",
  },
  iosHintButton: {
    marginTop: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 16,
    backgroundColor: "#eff6ff",
  },
  iosHintText: {
    color: "#2563eb",
    fontSize: 13,
    lineHeight: 20,
  },
  formError: {
    width: "100%",
    maxWidth: 760,
    marginBottom: 14,
    padding: 16,
    borderRadius: 18,
    backgroundColor: "#fff1f2",
    borderWidth: 1,
    borderColor: "#fecaca",
    color: "#b91c1c",
    fontSize: 14,
    lineHeight: 20,
  },
  emptyMessage: {
    fontSize: 14,
    color: "#4b5563",
    lineHeight: 20,
  },
});
